export const DEFAULT_CONFIG = {
	id: 1,
	version: 1,
	meta: {
		timezone: 'Asia/Aqtobe',
		utc_offset: '+05:00',
		phone: {
			code: '+7'
		},
		country: {
			code: 'KZ',
			name: 'Kazakhstan'
		},
		money: {
			default: 'KZT',
			currencies: {
				KZT: {
					symbol: '₸',
					symbol_position: 'after',
					thousand_separator: ' ',
					decimal_separator: ' ',
					format: '# ###',
					fraction_digits: 0,
					rounding: {
						mode: 'floor',
						precision: 0
					}
				}
			}
		},
		locale: {
			default: 'kk',
			fallback: 'ru',
			supported: ['kk', 'ru', 'en', 'hi', 'zh', 'uz', 'tr']
		}
	}
};
